module.exports = __webpack_public_path__ + "img/downArrowC.7687c547.svg";